<template>

        <v-select
                prepend-icon="fact_check"
                :items="items"
                v-model="item"
                :label="$t('cobrox.factura.labels.tipo')"
                :loading="loading"
                :error="hasInputErrors('tipo')"
                :error-messages="getInputErrors('tipo')"
                color="secondary"
                item-color="secondary"
                :rules="required"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'



    export default {
        name: "TipoCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {
               type: [String, Array]
            },
        },
        data() {
            return {
                items: ['FACTURABLE','NO_FACTURABLE'],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        }
    }
</script>

<style scoped>

</style>

